import { Icon } from "@iconify/react";
import { useCallback, useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { getMainProgramDetails, getMyProgram } from "../../api/api";
import { BlueTextLinearGradient, WhiteLinearGradient } from "../../utils/Utils";
import { MemoizedPrograms, SkeletonPrograms } from "./Programs";

function ProgramDetailsPage() {
  const { programId } = useParams();
  const [programDetails, setProgramDetails] = useState();

  const navigate = useNavigate();

  const updatePrograms = useCallback(async () => {
    const response = await getMainProgramDetails(programId);
    if (response) setProgramDetails(response);
  }, []);

  useEffect(() => {
    updatePrograms();
  }, []);

  return (
    <div className={`w-full h-full pt-10 bg-[#0E0E11]`}>
      {programDetails ? (
        <>
          <div className="flex flex-col  md:flex-row pt-10 px-6 md:px-16 lg:px-24 2xl:px-32 md:space-x-5">
            <div
              className="w-10 h-10 hover:cursor-pointer"
              onClick={() => {
                // navigate("/exercise");
                navigate("/programpage");
              }}
            >
              <Icon
                icon={"akar-icons:circle-chevron-left"}
                className="w-10 h-10 text-primary-purple "
              />
            </div>
            <div className="flex flex-col ">
              <p
                className={`font-semibold text-3xl ${BlueTextLinearGradient} `}
              >
                {programDetails.programName}
              </p>
              <p className={`font-medium text-lg ${BlueTextLinearGradient} `}>
                {programDetails.programDays} Days Program
              </p>
              <p className={`dark:text-white`}>{programDetails.description}</p>
            </div>
          </div>

          <MemoizedPrograms
            updatePrograms={updatePrograms}
            programId={programId}
            programName={"Here is your 21 day recommended program."}
            program={programDetails.exercises}
          />
        </>
      ) : (
        <div className="px-6 md:px-16 lg:px-24 2xl:px-32">
          <SkeletonPrograms />
        </div>
      )}
    </div>
  );
}

export default ProgramDetailsPage;
